var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"span":_vm.span,"offset":_vm.offset,"push":_vm.push,"pull":_vm.pull,"xs":_vm.xs,"sm":_vm.sm,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl,"tag":_vm.tag}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }